import React from "react";
import { useLocation } from "react-router-dom";

import Footer from "../../components/Footer/Footer";
import Navbar from "../../components/Navbar/Navbar";

const BaseLayout = (props) => {
  const location = useLocation();

  // Ocultar footer en /novedades
  const hideFooterPaths = ["/novedades"];
  const shouldHideFooter = hideFooterPaths.includes(location.pathname);

  return (
    <div className="d-flex flex-column justify-content-between">
      <Navbar />
      <main id="wrapper">{props.children}</main>
      {!shouldHideFooter && <Footer />}
    </div>
  );
};

export default BaseLayout;
